import { SubscriberController } from "../../../../services/controllers/subscription";

import { Drawer } from "../../../../components/ui/Drawer";
import { Accordion } from "../../../../components/ui/Accordion";

import { SubscriptionDetailsHeader } from "./SubscriptionDetailsHeader";
import { SubscriptionDetailsTitle } from "./SubscriptionDetailsTitle";
import { SubscriptionDetailsCycles } from "./SubscriptionDetailsCycles";
import { SubscriptionDetailsPlans } from "./SubscriptionDetailsPlans";
import { SubscriptionPriceUpdate } from "./SubscriptionPriceUpdate";
import { Container } from "./styles";

export function SubscriptionDetails() {
  const CSubscriber = SubscriberController();

  return (
    <>
      <Drawer.Root name={CSubscriber.subscriptionDetailsDrawerName} direction="left" style={{ minWidth: ' 800px' }}>
        <Drawer.Controls controls={{ close: CSubscriber.closeDetailsDrawer }} />
        <Drawer.Header>
          <SubscriptionDetailsTitle />
        </Drawer.Header>
        <Drawer.Content style={{ flexDirection: 'column', flexWrap: 'nowrap' }}>
          <SubscriptionDetailsHeader />
          <Container>
            <Accordion.Root name="subscription-details" options={{ type: "multiple" }}>
              <Accordion.Item title="Alteração de plano">
                <Accordion.Content>
                  <SubscriptionDetailsPlans />
                </Accordion.Content>
              </Accordion.Item>

              <Accordion.Item title="Reajuste de Assinatura">
                <Accordion.Content>
                  <SubscriptionPriceUpdate />
                </Accordion.Content>
              </Accordion.Item>

              <Accordion.Item title="Detalhes de Pagamento">
                <Accordion.Content>
                  <SubscriptionDetailsCycles />
                </Accordion.Content>
              </Accordion.Item>
            </Accordion.Root>
          </Container>
        </Drawer.Content>
        <Drawer.Footer />
      </Drawer.Root>
    </>
  )
}
